<div class="controlli-sezione">
  <input class="d-none" type="file" accept=".xlsx,.xls" #fileInput (click)="cleanInput($event)" (input)="upload($event)" />

  <div class="d-flex justify-content-end">
    <button mat-button color="primary" (click)="openCodiciAmmessi()">
      <mat-icon>info</mat-icon>
      Visualizza codici {{ type === 'prelievi' ? 'Parametri Analitici' : 'Superamenti Reportnet3' }} ammessi
    </button>
  </div>

  <div class="drop-zone" appDropZone (fileDropped)="upload($event)">
    <button
      mat-icon-button
      class="template-info-button"
      color="primary"
      matTooltip="Template Excel caricamento dati"
      (click)="openTemplateInfo()"
    >
      <mat-icon>description</mat-icon>
    </button>
    <mat-icon class="drop-zone-icon">cloud_upload</mat-icon>
    <button mat-stroked-button color="primary" (click)="fileInput.click()" [disabled]="validating || saving">
      <mat-icon>upload_file</mat-icon>
      Sfoglia file Excel
    </button>
    <span class="drop-zone-text" *ngIf="fileName">{{ fileName }}</span>
    <span class="drop-zone-text" *ngIf="!fileName">oppure trascina qui il file</span>
  </div>

  <div class="table-wrapper mt-2" *ngIf="rows.length">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="w-100">
    <ng-container matColumnDef="riga">
      <th mat-header-cell *matHeaderCellDef>Riga</th>
      <td mat-cell *matCellDef="let row">{{ row.riga }}</td>
    </ng-container>

    <ng-container matColumnDef="uuid">
      <th mat-header-cell *matHeaderCellDef>Punto di campionamento</th>
      <td mat-cell *matCellDef="let row">{{ row.data.uuid }}</td>
    </ng-container>

    <ng-container matColumnDef="dataOraPrelievo">
      <th mat-header-cell *matHeaderCellDef>Data prelievo</th>
      <td mat-cell *matCellDef="let row">{{ formatData(row.data.dataOraPrelievo) }}</td>
    </ng-container>

    <ng-container matColumnDef="codicePrelievo">
      <th mat-header-cell *matHeaderCellDef>Prelievo</th>
      <td mat-cell *matCellDef="let row">{{ row.data.codicePrelievo }}</td>
    </ng-container>

    <ng-container matColumnDef="codiceParametro">
      <th mat-header-cell *matHeaderCellDef>Parametro</th>
      <td mat-cell *matCellDef="let row">{{ row.data.codiceParametro }}</td>
    </ng-container>

    <ng-container matColumnDef="valore">
      <th mat-header-cell *matHeaderCellDef>Valore misurato</th>
      <td mat-cell *matCellDef="let row">{{ formatValore(row) }}</td>
    </ng-container>

    <ng-container matColumnDef="unitaMisura">
      <th mat-header-cell *matHeaderCellDef>Unità di misura</th>
      <td mat-cell *matCellDef="let row">{{ getUnitaMisura(row) | unitaMisura }}</td>
    </ng-container>

    <ng-container matColumnDef="tipologiaPuntoDiConformita">
      <th mat-header-cell *matHeaderCellDef>Tipologia punto</th>
      <td mat-cell *matCellDef="let row">{{ row.data.tipologiaPuntoDiConformita }}</td>
    </ng-container>

    <ng-container matColumnDef="superamento">
      <th mat-header-cell *matHeaderCellDef>Superamento</th>
      <td mat-cell *matCellDef="let row">{{ formatBooleano(row.data.superamento) }}</td>
    </ng-container>

    <ng-container matColumnDef="esito">
      <th mat-header-cell *matHeaderCellDef>Esito</th>
      <td mat-cell *matCellDef="let row">
        <mat-icon *ngIf="row.valido" color="primary">check_circle</mat-icon>
        <ng-container *ngIf="!row.valido">
          <mat-icon color="warn">error</mat-icon>
          <mat-icon class="expand-icon">{{ expandedRows.has(row.riga) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="errori">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columns.length" class="errori-cell">
        <ul class="errori-list" *ngIf="expandedRows.has(row.riga)">
          <li *ngFor="let errore of row.errori">{{ errore }}</li>
        </ul>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns" [class.row-invalid]="!row.valido"
      (click)="toggleRow(row)"></tr>
    <tr mat-row *matRowDef="let row; columns: ['errori']; when: isInvalidRow" class="errori-row"
      [class.errori-row-open]="expandedRows.has(row.riga)"></tr>
  </table>
  </div>

  <mat-paginator *ngIf="rows.length" [pageSize]="50" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

  <div class="d-flex align-items-center justify-content-between mt-2 save-bar" *ngIf="rows.length">
    <span>{{ validRowCount }} / {{ rows.length }} righe valide</span>
    <div class="d-flex">
      <button mat-stroked-button color="primary" [disabled]="validating || saving" (click)="reset()">
        <mat-icon>clear</mat-icon>
        Annulla
      </button>
      <button mat-raised-button color="primary" [disabled]="!validRowCount || saving" (click)="save()">
        <mat-icon>save</mat-icon>
        Salva
      </button>
    </div>
  </div>
</div>
